export const STYLES_SET_FOR_ALIGN = {
  left: { maxWidth: 'fit-content', margin: '0' },
  center: { maxWidth: 'fit-content', margin: '0 auto' },
  right: { maxWidth: 'fit-content', margin: '0 0 0 auto' },
  justify: { width: '100%', maxWidth: 'none' },
}
